import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as actionTypes from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const MODULES = actionTypes.GLOBAL_STATE

const modulesSlice = createSlice({
  name: MODULES,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.modules.pending, state => {
        state[actionTypes.MODULES].loading = true
      })
      .addCase(actionCreators.modules.rejected, (state, action) => {
        state[actionTypes.MODULES].loading = false
        state[actionTypes.MODULES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.modules.fulfilled, (state, action) => {
        state[actionTypes.MODULES].loading = false
        state[actionTypes.MODULES].error = null
        state[actionTypes.MODULES].data = action.payload
      })

    builder
      .addCase(actionCreators.modulesAll.pending, state => {
        state[actionTypes.MODULES_ALL].loading = true
      })
      .addCase(actionCreators.modulesAll.rejected, (state, action) => {
        state[actionTypes.MODULES_ALL].loading = false
        state[actionTypes.MODULES_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.modulesAll.fulfilled, (state, action) => {
        state[actionTypes.MODULES_ALL].loading = false
        state[actionTypes.MODULES_ALL].error = null
        state[actionTypes.MODULES_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.modulesCreate.pending, state => {
        state[actionTypes.MODULES_CREATE].loading = true
      })
      .addCase(actionCreators.modulesCreate.rejected, (state, action) => {
        state[actionTypes.MODULES_CREATE].loading = false
        state[actionTypes.MODULES_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.modulesCreate.fulfilled, (state, action) => {
        state[actionTypes.MODULES_CREATE].loading = false
        state[actionTypes.MODULES_CREATE].error = null
        state[actionTypes.MODULES_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.modulesDelete.pending, state => {
        state[actionTypes.MODULES_DELETE].loading = true
      })
      .addCase(actionCreators.modulesDelete.rejected, (state, action) => {
        state[actionTypes.MODULES_DELETE].loading = false
        state[actionTypes.MODULES_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.modulesDelete.fulfilled, (state, action) => {
        state[actionTypes.MODULES_DELETE].loading = false
        state[actionTypes.MODULES_DELETE].error = null
        state[actionTypes.MODULES_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.modulesList.pending, state => {
        state[actionTypes.MODULES_LIST].loading = true
      })
      .addCase(actionCreators.modulesList.rejected, (state, action) => {
        state[actionTypes.MODULES_LIST].loading = false
        state[actionTypes.MODULES_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.modulesList.fulfilled, (state, action) => {
        state[actionTypes.MODULES_LIST].loading = false
        state[actionTypes.MODULES_LIST].error = null
        state[actionTypes.MODULES_LIST].data = action.payload
      })

    builder.addCase(actionCreators.modulesClear, state => {
      state[actionTypes.MODULES] = defaultState()
    })

    builder.addCase(actionCreators.modulesAllClear, state => {
      state[actionTypes.MODULES_ALL] = defaultState()
    })

    builder.addCase(actionCreators.modulesListClear, state => {
      state[actionTypes.MODULES_LIST] = defaultState()
    })
  },
})

export const { reducer: modulesReducer } = modulesSlice
